
<template>
    <v-tooltip text="Download Template" location="bottom">
        <template #activator="{ props }">
            <!-- <v-btn v-bind="props" color="#fff" > -->
                <v-icon  v-bind="props" start @click="downloadExcel"> mdi-file-document-outline</v-icon>
            <!-- </v-btn> -->
        </template>
    </v-tooltip>
</template>
  
  <script>
  import * as XLSX from "xlsx";
  
  export default {
    props: {
    data: {
        type: Array,
        required: true, 
        },
    text: {
        type: String,
        required: true
    }
    },
    methods: {
      downloadExcel() {
        const headers = [this.data];
  
        const worksheet = XLSX.utils.aoa_to_sheet(headers);
  
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, this.text);
  
        XLSX.writeFile(workbook, `${this.text}Template.xlsx`);
      },
    },
  };
  </script>
  